export const INITIALIZE_READINESS_CHECK = 'initializeReadinessCheck';

export const PASSED = 'passed';
export const FAILED = 'failed';
export const CHECKING = 'checking';
export const WAITING = 'waiting';
export const PERMISSION_DENIED = 'permission_denied';
export const NO_DEVICE_FOUND = 'no_device_found';
export const SKIPPED = 'skipped';
